export type TemplateParams = {
  href: string;
  envLabel: string;
  tenantLabel?: string;
  tenantId?: string;
  facilityDisplay?: string;
  facilityProfileUrl?: string;
  reportId?: string;
  sentryReplayUrl?: string;
  pageTitle?: string;
};

export function templateLinearTicket({
  href,
  envLabel,
  tenantLabel,
  tenantId,
  facilityDisplay,
  facilityProfileUrl,
  reportId,
  sentryReplayUrl,
  pageTitle,
}: TemplateParams): { title: string; description: string } {
  const tenantLine =
    tenantId != null && tenantId !== ""
      ? tenantLabel
        ? `**Customer(s)**: ${tenantLabel} - ${tenantId}`
        : `**Customer(s)**: ${tenantId}`
      : `**Customer(s)**: ${tenantLabel ?? ""}`;

  const facilityLine =
    facilityProfileUrl && facilityDisplay
      ? `**Facility/Facilities (link)**: [${facilityDisplay}](${facilityProfileUrl})`
      : "**Facility/Facilities (link)**: ";

  const reportLine = reportId ? `**Report ID**: ${reportId}` : undefined;
  const sentryLine = sentryReplayUrl ? `**Sentry link**: ${sentryReplayUrl}` : undefined;

  const lines = [
    "**Urgency** (Low, Medium: a month or longer, High: less than a month, Urgent: less than a week):",
    "\n",
    "**Due Date** (or customer commit):",
    "\n",
    tenantLine,
    "\n",
    facilityLine,
    "\n",
    ...(reportLine ? [reportLine, "\n"] : []),
    ...(sentryLine ? [sentryLine, "\n"] : []),
    "**Description** (please add context, known workarounds, etc):",
    "\n",
    "---",
    "\n",
    `**Origin env**: ${envLabel}`,
    `**Origin URL**: ${pageTitle ? `${pageTitle} - ` : ""}${href}`,
  ].filter(Boolean);
  const description = lines.join("\n");

  const title =
    (facilityDisplay &&
      `Engineering Support: ${tenantLabel ? `${tenantLabel} - ` : ""}${facilityDisplay}`) ||
    (tenantLabel && `Engineering Support: ${tenantLabel}`) ||
    "Engineering Support: ";

  return { title, description };
}

export const linearIdentifiers = {
  project: "ccb7f15f-8a8d-414b-983d-01c416262b31",
  status: "Triage",
  labels: "engineering-support",
  organization: "encamp",
};

export function buildLinearNewIssueUrl(paramsIn: { title: string; description: string }): string {
  const params = new URLSearchParams();
  params.set("title", paramsIn.title);
  params.set("description", paramsIn.description);
  params.set("project", linearIdentifiers.project);
  params.set("status", linearIdentifiers.status);
  params.set("labels", linearIdentifiers.labels);
  return `https://linear.app/${linearIdentifiers.organization}/new?${params.toString()}`;
}
